import { Add, Create, Payment, Update } from "@mui/icons-material";
import { lazy } from "react";
import Createtags from "./pages/admin/tags/Createtags";
import SuccessPage from "./components/sections/pricing-plan/success";
import LaunchAssessment from "./pages/client/assessmentv2/launch-assessment";
import RunningAssessments from "./pages/client/assessmentv2/running-assessment";
import AssessmentSummary from "./pages/student/AssessmentSummary";
import MakeMyReport from "./pages/client/assessment_report/make-my-report";
import AddEnterpriseAdmin from "./pages/admin/users/AddEnterpriseAdmin";
import AddLicenseRequest from "./pages/admin/EnterpriseAdmin/AddLicenseRequest";

const routes = {
  LandingPage: lazy(() => import("./components/LandingPage")),
  PrivacyPolicy: lazy(
    () => import("./components/sections/policy-pages/PrivacyPolicy"),
  ),
  TermsOfService: lazy(
    () => import("./components/sections/policy-pages/TermsOfService"),
  ),
  CookiePolicy: lazy(
    () => import("./components/sections/policy-pages/CookiePolicy"),
  ),
  RefundPolicy: lazy(
    () => import("./components/sections/policy-pages/RefundPolicy"),
  ),
  Login: lazy(() => import("./pages/Login")),
  AssessmentTokenPage: lazy(
    () => import("./pages/student/AssessmentTokenPage"),
  ),
  NotFoundPage: lazy(() => import("./components/404Page")),
  ProfileDashboard: lazy(() => import("./pages/Profile")),
  UserManagement: lazy(() => import("./pages/admin/users/users")),
  Problems: lazy(() => import("./pages/author/problem/problems")),
  AiProblems: lazy(() => import("./pages/author/problem/problems")),
  CreateAiCoding: lazy(() => import("./pages/author/problem/createAiProblem")),
  AiMCQs: lazy(() => import("./pages/author/mcq/problems")),
  CreateAiMCQ: lazy(() => import("./pages/author/mcq/createAiMcq")),
  CreateProblem: lazy(() => import("./pages/author/problem/createProblem")),
  CreateMCQ: lazy(() => import("./pages/author/mcq/createMcq")),
  MCQs: lazy(() => import("./pages/author/mcq/problems")),
  ClientList: lazy(() => import("./pages/admin/client/ManageClients")),
  CreateClient: lazy(() => import("./pages/admin/client/CreateClient")),
  UpdateClient: lazy(() => import("./pages/admin/client/UpdateClient")),
  UpdateMCQ: lazy(() => import("./pages/author/mcq/updateMcq")),
  UpdateProblem: lazy(() => import("./pages/author/problem/updateProblem")),
  ClientDetails: lazy(() => import("./pages/client/ClientDetails")),
  ClientUserManagement: lazy(() => import("./pages/client/UserManagement")),
  Assessments: lazy(() => import("./pages/assessment/Assessments")),
  CreateAssessment: lazy(() => import("./pages/assessment/CreateAssessment")),
  ProblemPage: lazy(() => import("./pages/problem/ProblemPage")),
  UpdateAssessment: lazy(() => import("./pages/assessment/UpdateAssessment")),
  CreateUser: lazy(() => import("./pages/admin/users/CreateUser")),
  AssessmentDetailsPage: lazy(
    () => import("./pages/assessment/AssessmentEnv/AssessmentDetailsPage"),
  ),
  AssessmentHomePage: lazy(
    () => import("./pages/assessment/AssessmentEnv/AssessmentHomePage"),
  ),
  ManagePlans: lazy(() => import("./pages/admin/plans/ManagePlans")),
  CreatePlan: lazy(() => import("./pages/admin/plans/CreatePlan")),
  UpdatePlan: lazy(() => import("./pages/admin/plans/UpdatePlan")),
  SubscribeToPlan: lazy(() => import("./components/SubscribeToPlan")),
  PaymentSuccess: lazy(() => import("./components/PaymentSuccess")),
  UserGroupManagement: lazy(() => import("./pages/client/userGroupMangement")),
  ProctorApp: lazy(() => import("./components/Proctoring/ProctorApp")),
  CreateUsersTabs: lazy(() => import("./pages/client/CreateUsers")),
  CreateGroups: lazy(() => import("./pages/client/CreateGroups")),
  CreateGroupUsers: lazy(() => import("./pages/client/CreateGroupUsers")),
  EyeTrackingComponent: lazy(
    () => import("./components/Proctoring/EyeTrackingComponent"),
  ),
  TestApp: lazy(() => import("./components/Test")),
  Tags: lazy(() => import("./pages/admin/tags/Tagmanagementpage")),
  CreateTags: lazy(() => import("./pages/admin/tags/Createtags")),
  UpdateTags: lazy(() => import("./pages/admin/tags/Updatetags")),
  companyTags: lazy(() => import("./pages/admin/company-tags/company-tags")),
  CreateCompanyTags: lazy(
    () => import("./pages/admin/company-tags/create-company-tags"),
  ),
  UpdateCompanyTags: lazy(
    () => import("./pages/admin/company-tags/update-company-tags"),
  ),
  UserPage: lazy(() => import("./pages/admin/users/UserPage")),
  ReviewMcqs: lazy(() => import("./pages/moderator/ViewAllMcqs")),
  ModeratorDashboard: lazy(
    () => import("./pages/moderator/moderator-dashboard"),
  ),
  ModeratorReviewPage: lazy(
    () => import("./pages/moderator/moderator-review-page"),
  ),
  CodingModeratorDashboard: lazy(
    () => import("./pages/moderator/coding-problem-moderator-dashboard"),
  ),
  CodingModeratorReviewPage: lazy(
    () => import("./pages/moderator/coding-problem-moderator-review"),
  ),
  ReviewMcq: lazy(() => import("./pages/moderator/ReviewMcq")),
  AuthorContributions: lazy(
    () => import("./pages/admin/author/AuthorContributions"),
  ),

  UserAssessmentReport: lazy(
    () => import("./pages/client/reports/UserAssessmentReport"),
  ),
  Sections: lazy(() => import("./pages/client/sections/Sections")),
  CreateSection: lazy(() => import("./pages/client/sections/CreateSection")),
  UpdateSection: lazy(() => import("./pages/client/sections/UpdateSection")),
  Patterns: lazy(() => import("./pages/client/patterns/Patterns")),
  CreatePattern: lazy(() => import("./pages/client/patterns/CreatePattern")),
  UpdatePattern: lazy(() => import("./pages/client/patterns/UpdatePattern")),
  Createtags: lazy(() => import("./pages/admin/tags/Createtags")),
  Updatetags: lazy(() => import("./pages/admin/tags/Updatetags")),
  UpdateAssessmentV2: lazy(
    () => import("./pages/client/assessmentv2/UpdateAssessmentDetails"),
  ),
  AssessmentsV2: lazy(() => import("./pages/client/assessmentv2/Assessments")),
  CreateAssessmentV2: lazy(
    () => import("./pages/client/assessmentv2/CreateAssessmentDetails"),
  ),
  LaunchAssessmentV2: lazy(
    () => import("./pages/client/assessmentv2/launch-assessment"),
  ),
  RunningAssessmentsV2: lazy(
    () => import("./pages/client/assessmentv2/running-assessment"),
  ),
  ScheduleAssessmentV2: lazy(
    () => import("./pages/client/assessmentv2/schedule-assessment"),
  ),
  AdminSections: lazy(() => import("./pages/admin/sections/adminSection")),
  StudentForm: lazy(
    () => import("./components/sections/pricing-plan/student-form"),
  ),
  InstitutionForm: lazy(
    () => import("./components/sections/pricing-plan/institution-form"),
  ),
  CompanyForm: lazy(
    () => import("./components/sections/pricing-plan/company-form"),
  ),
  OrganizationTypePage: lazy(
    () => import("./components/sections/pricing-plan/organization-type"),
  ),
  PaymentPage: lazy(() => import("./components/sections/pricing-plan/payment")),
  SuccessPage: lazy(() => import("./components/sections/pricing-plan/success")),
  LoginPlan: lazy(() => import("./components/sections/login-plan")),
  MCQDetails: lazy(() => import("./pages/author/mcq/mcqDetails")),

  AssessmentOverview: lazy(() => import("./pages/student/AssessmentOverview")),

  AssessmentOnboarding: lazy(
    () => import("./pages/student/AssessmentOnboarding"),
  ),

  AssessmentTest: lazy(
    () => import("./pages/student/TestEnvironment/AssessmentTest"),
  ),
  ProblemDetails: lazy(() => import("./pages/author/problem/problemDetails")),

  AuthorManagementSummary: lazy(
    () => import("./pages/admin/authorManagement/summary"),
  ),
  AssessmentUsers: lazy(
    () => import("./pages/client/assessmentv2/AssessmentUsersList"),
  ),
  AssessmentUserReport: lazy(
    () => import("./pages/client/assessmentv2/AssessmentUserReport"),
  ),

  AssessmentWiseUserReport: lazy(
    () => import("./pages/client/assessment_report/assessment-wise-report"),
  ),
  UserGroupWiseReport: lazy(
    () => import("./pages/client/assessment_report/user-group-wise-report"),
  ),
  StudentWiseReport: lazy(
    () => import("./pages/client/assessment_report/student-wise-report"),
  ),
  CustomAssessmentReport: lazy(
    () => import("./pages/client/assessment_report/custom-assessment-report"),
  ),
  ClientWiseReport: lazy(
    () => import("./pages/client/assessment_report/client-wise-report"),
  ),

  MakeMyReport: lazy(
    () => import("./pages/client/assessment_report/make-my-report"),
  ),
  CodingProblemViewer: lazy(
    () => import("./pages/author/problem/coding-problem-viewer"),
  ),

  ContentFA: lazy(
    () =>
      import(
        "./pages/client/assessment_fitment_analysis/content-fitment-analysis"
      ),
  ),

  CompanyFA: lazy(
    () =>
      import(
        "./pages/client/assessment_fitment_analysis/company-fitment-analysis"
      ),
  ),

  JobRoleFA: lazy(
    () =>
      import(
        "./pages/client/assessment_fitment_analysis/job-role-fitment-analysis"
      ),
  ),
  JobRolesTopic: lazy(
    () => import("./pages/client/assessment_fitment_analysis/admin-role-map"),
  ),
  StudentListForAssessment: lazy(
    () => import("./pages/client/assessmentv2/student-list-for-assessment"),
  ),
  CreateCsvProblem: lazy(
    () => import("./pages/author/problem/createCsvProblem"),
  ),
  CreateCsvMcq: lazy(() => import("./pages/author/mcq/createCsvMcq")),
  QuestionReports: lazy(
    () => import("./pages/admin/ReportQuestions/question-report"),
  ),
  McqBankOverview: lazy(
    () => import("./pages/admin/questionBankOverview/MCQOverview"),
  ),
  CodingBankOverview: lazy(
    () => import("./pages/admin/questionBankOverview/CodingOverview"),
  ),
  LiveMonitor: lazy(() => import("./pages/client/assessmentv2/LiveMonitor")),
  SignupSuccessPage: lazy(
    () =>
      import("./components/sections/pricing-plan/SignupSuccessConfirmation"),
  ),
  ContactSalesDashboard: lazy(
    () => import("./pages/admin/RequestDasboard/SalesRequestDashboard"),
  ),
  RequestDemoDashboard: lazy(
    () => import("./pages/admin/RequestDasboard/DemoRequestDashboard"),
  ),
  CreateCoupon: lazy(
    () => import("./pages/admin/couponManagement/CreateCoupon"),
  ),
  ViewCoupons: lazy(() => import("./pages/admin/couponManagement/ViewCoupons")),

  LeaderboardPage: lazy(
    () => import("./components/sections/LeaderboardSection"),
  ),

  CompanyRegistration: lazy(
    () => import("./components/sections/CompanyRegistration"),
  ),

  CompanyLayout: lazy(() => import("./components/sections/CompanyLayout")),

  CompanyOverview: lazy(
    () => import("./components/sections/company-pages/CompanyOverview"),
  ),

  PostJob: lazy(() => import("./components/sections/company-pages/PostJob")),

  ApplicantsView: lazy(
    () => import("./components/sections/company-pages/ApplicantsView"),
  ),

  JobLeaderboard: lazy(
    () => import("./components/sections/company-pages/JobLeaderboard"),
  ),

  CompanySettings: lazy(
    () => import("./components/sections/company-pages/CompanySettings"),
  ),

  ViewJobs: lazy(() => import("./components/sections/ViewJobs")),

  ApplyJob: lazy(() => import("./components/sections/ApplyJobs")),

  OnboardedCompanies: lazy(
    () => import("./components/sections/OnboardedCompanies"),
  ),

  CareerJobPost: lazy(
    () => import("./pages/admin/careerManagement/AdminPostJob"),
  ),

  ViewCareerJobs: lazy(() => import("./components/sections/ViewCareerJobs")),

  ApplyCareerJob: lazy(() => import("./components/sections/ApplyCareerJob")),

  AdminViewJobs: lazy(
    () => import("./pages/admin/careerManagement/AdminViewJobs"),
  ),

  AdminViewApplicants: lazy(
    () => import("./pages/admin/careerManagement/AdminViewApplicants"),
  ),

  StudentDashboard: lazy(() => import("./pages/student/StudentDashboard")),

  HireUs: lazy(() => import("./components/sections/HireWithUs")),

  EmailLogin: lazy(() => import("./pages/EmailLogin")),

  ForgotPassword: lazy(() => import("./pages/ForgotPassword")),

  ViewAgencies: lazy(
    () => import("./pages/admin/RecruitmentAgency/ViewAgencies"),
  ),

  CreateAgency: lazy(() => import("./pages/admin/RecruitmentAgency/AddAgency")),

  ViewEmployers: lazy(() => import("./pages/client/ViewEmployers")),

  AddEmployer: lazy(() => import("./pages/client/AddEmployer")),

  ViewApplicantsJobs: lazy(() => import("./pages/client/ViewJobs")),

  CompanyAssessmentReports: lazy(
    () => import("./components/sections/CompanyAssessmentReports"),
  ),
  AgencyLinkedStudents: lazy(
    () => import("./pages/admin/studentManagement/AgencyLinkedStudents"),
  ),
  CollegeLinkedStudents: lazy(
    () => import("./pages/admin/studentManagement/CollegeLinkedStudents"),
  ),
  IndividualsLinkedStudents: lazy(
    () => import("./pages/admin/studentManagement/IndividualStudents"),
  ),

  ViewCandidates: lazy(() => import("./pages/client/ViewCandidates")),

  AddCandidates: lazy(() => import("./pages/client/AddCandidates")),

  AgencyPostJob: lazy(
    () => import("./pages/admin/AgencyJobsManagement/PostJob"),
  ),

  StudentJobsManagement: lazy(
    () => import("./pages/studentJobDashboard/JobsManagement"),
  ),

  AgencyJobsManagement: lazy(
    () => import("./pages/admin/AgencyJobsManagement/ViewAgencyJobs"),
  ),

  AgencyManageApplicants: lazy(
    () => import("./pages/admin/AgencyJobsManagement/ManageApplicants"),
  ),

  BulkAddApplicants: lazy(
    () => import("./pages/admin/AgencyJobsManagement/BulkAddApplicants"),
  ),

  AgencyJobsForCompany: lazy(
    () => import("./components/sections/company-pages/AgencyJobsForCompany"),
  ),

  AgencyEditJob: lazy(
    () => import("./pages/admin/AgencyJobsManagement/JobVisibilityManager"),
  ),

  ApplicantsFitmentAnalysis: lazy(
    () =>
      import("./pages/admin/AgencyJobsManagement/ApplicantsFitmentAnalysis"),
  ),

  ShareJobReport: lazy(
    () => import("./pages/admin/AgencyJobsManagement/viewJobs"),
  ),

  EditJob: lazy(() => import("./components/sections/company-pages/EditJob")),

  CreateUnifiedProblem: lazy(
    () => import("./pages/author/UnifiedQuestionCreator"),
  ),

  CSVUploadUnified: lazy(() => import("./pages/author/CSVUploadUnified")),
  CSVUploadHistory: lazy(() => import("./pages/author/CSVUploadHistory")),

  UnifiedQuestionUpdate: lazy(
    () => import("./pages/author/UnifiedQuestionUpdate"),
  ),

  UnifiedQuestionBank: lazy(() => import("./pages/author/UnifiedQuestionBank")),

  UnifiedQuestionDetail: lazy(
    () => import("./pages/author/UnifiedQuestionDetail"),
  ),

  UnifiedModeratorDashboard: lazy(
    () => import("./pages/author/UnifiedModeratorDashboard"),
  ),

  QuestionBankOverview: lazy(
    () => import("./pages/author/QuestionBankOverview"),
  ),

  AddAuthor: lazy(() => import("./pages/admin/author/AddAuthor")),

  AddModerator: lazy(() => import("./pages/admin/moderator/AddModerator")),

  ViewAuthor: lazy(() => import("./pages/admin/author/ViewAuthor")),

  ViewModerator: lazy(() => import("./pages/admin/moderator/ViewModeartor")),

  AddContentHead: lazy(() => import("./pages/admin/users/AddContentHead")),
  ViewContentHead: lazy(() => import("./pages/admin/users/ViewContentHeads")),

  AddSuperAccess: lazy(() => import("./pages/admin/users/AddSuperAccess")),
  ViewSuperAccess: lazy(() => import("./pages/admin/users/ViewSuperAccess")),

  AddConsultants: lazy(() => import("./pages/client/AddConsultants")),
  ViewConsultants: lazy(() => import("./pages/client/ViewConsultants")),

  AddBusinessUnit: lazy(() => import("./pages/client/AddBusinessUnit")),
  ViewBusinessUnits: lazy(() => import("./pages/client/ViewBusinessUnits")),

  AssignConsultantsToBU: lazy(() => import("./pages/client/AssignConsultantsToBU"), ),

  AddConsultantsToBU : lazy(() => import("./pages/client/BUAddConsultants"), ),
  ViewConsultantsToBU : lazy(() => import("./pages/client/BUViewConsultants"), ),
  AssignConsultants: lazy(() => import("./pages/client/BUClaimConsultants")),
  SuperAdminAddGroup: lazy(() => import("./pages/client/SuperAdminAddGroup")),
  SuperAdminViewGroups: lazy(() => import("./pages/client/SuperAdminViewGroups")),
  BUAssignGroupConsultants: lazy(() => import("./pages/client/BUAssignConsultants")),
  BUGroupsManagement: lazy(() => import("./pages/client/BUGroupManagement")),
  SuperAdminReportsSummary: lazy(() => import("./pages/client/assessment_report/SuperAdminReportsSummary")),
  SuperAdminBusinessUnitWiseReport: lazy(
    () => import("./pages/client/assessment_report/business-unit-wise-report"),
  ),
  AddEnterpriseAdmin: lazy(() => import("./pages/admin/users/AddEnterpriseAdmin")),
  ViewEnterpriseAdmin: lazy(() => import("./pages/admin/users/ViewEnterpriseAdmin")),
  AddLicenseRequest: lazy(() => import("./pages/admin/EnterpriseAdmin/AddLicenseRequest")),
  ViewLicenseRequests: lazy(() => import("./pages/admin/EnterpriseAdmin/ViewLicenseRequests")),
  AdminReviewLicenses: lazy(() => import("./pages/admin/users/AdminReviewLicenses")),

  CodingToDebuggingStudio: lazy(
    () => import("./pages/author/CodingToDebuggingStudio"),
  ),

  AdminGlobalJobManagement: lazy(
    () => import("./pages/admin/globalJobsView/AdminGlobalJobManagement"),
  ),
};

export default routes;
